import React from 'react';
import { trackCustom } from '../utils/tracking';
const links = [{
  label: 'Reviews',
  href: '#reviews'
}, {
  label: 'Owner center',
  href: '/owner'
}, {
  label: 'Track my order',
  href: '/track'
}];
export function SiteNav() {
  return <header className="sticky top-0 z-40 border-b border-white/10 bg-ink-950/95 backdrop-blur" data-id="element-1351" data-mp="3alfzd5uvirh7">
      <nav aria-label="Main" className="mx-auto flex max-w-[1400px] items-center justify-between gap-4 px-4 py-2 sm:px-6 lg:px-8 lg:py-3" data-id="element-1352" data-mp="35nmrm8dx9pet">
        <a href="#top" className="shrink-0" data-id="element-1353" data-mp="2wn85x7x1q8as">
          <span className="block font-display text-2xl font-extrabold uppercase leading-none tracking-tight text-offwhite sm:text-3xl" data-id="element-1354" data-mp="2wpkmbgn5oalq">
            Grit<span className="text-grit-500" data-id="element-1355" data-mp="2mptpv9f1blj0">Vue</span>
            <sup className="ml-0.5 align-super text-[9px] text-steel-400" data-id="element-1356" data-mp="2mr4sv70nop92">™</sup>
          </span>
          <span className="mt-0.5 hidden text-[9px] font-semibold uppercase tracking-[0.3em] text-steel-400 sm:block" data-id="element-1357" data-mp="pw8pcduwes81">
            See the job through
          </span>
        </a>

        <ul className="hidden items-center gap-8 lg:flex" data-id="element-1358" data-mp="8yt37j1zqyd9">
          {links.map(link => <li key={link.href} data-id="element-1359" data-mp="dzgqpur0gx2q">
              <a href={link.href} className="text-xs font-bold uppercase tracking-[0.16em] text-steel-300 transition-colors duration-150 ease-grit hover:text-grit-500" data-id="element-1360" data-mp="dwm5w2435a8s">
                {link.label}
              </a>
            </li>)}
        </ul>

        <a href="#build-your-x1" onClick={() => trackCustom('nav_cta_clicked', {
        target: 'build'
      })} className="inline-flex shrink-0 items-center whitespace-nowrap bg-grit-500 px-3 py-2 font-display text-base font-extrabold uppercase leading-none tracking-wide text-ink-950 transition-[background-color,transform] duration-150 ease-grit hover:bg-grit-400 active:translate-y-[2px] sm:px-4 sm:text-lg" data-id="element-1361" data-mp="rsg51tf24l8p">
          Build your X1<span className="hidden sm:inline" data-id="element-1362" data-mp="1fgpur6fe5t54">&nbsp;— from $29.95</span>
        </a>
      </nav>

      <ul aria-label="Sections" className="flex justify-between gap-4 overflow-x-auto border-t border-white/10 px-4 py-1.5 sm:justify-center sm:gap-8 [-ms-overflow-style:none] [scrollbar-width:none] lg:hidden [&::-webkit-scrollbar]:hidden" data-id="element-1363" data-mp="1palpike6cxzf">
        {links.map(link => <li key={link.href} data-id="element-1364" data-mp="1bau5a1x2elcz">
            <a href={link.href} className="whitespace-nowrap text-[11px] font-bold uppercase tracking-[0.16em] text-steel-300 transition-colors duration-150 ease-grit hover:text-grit-500" data-id="element-1365" data-mp="1bbm37je4wv6f">
              {link.label}
            </a>
          </li>)}
      </ul>
    </header>;
}